/* eslint-disable multiline-ternary */
import React, { useEffect, useState } from 'react'
import { Container, Nav, Navbar } from 'react-bootstrap'
import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import styles from './style.module.scss'
// import sgMedia from '@assets/images/placeholder/SGMEDIA.svg'
import useGoogleIdentify from '@shared/hooks/useGoogleIdentify'
import { getToken } from '@shared/libs/token'
import MobileMenu from '@shared/components/mobileMenu'
// import useWindowSize from '@shared/hooks/windowSize'
// import sgMedia from '@assets/images/placeholder/SGMEDIA-LOGO.svg'
import { getHeaderSidebarMenu } from '@shared-submodule/sm-libs/menu'
import DownloadBanner from '../downloadBanner'
import CommonHeader from '@shared-submodule/sm-components/header'
import CommonHeaderMobile from '@shared-submodule/sm-components/header/mobile-header'
import { cricketHeaderMenu } from '@shared-submodule/sm-constants/allNavBars'
const DarkModeButton = dynamic(() => import('@shared/components/header/darkModeButton'), { ssr: false })
const HeaderMenu = dynamic(() => import('@shared/components/header/headerMenu'))
const MyImage = dynamic(() => import('@shared/components/myImage'))
const CustomLink = dynamic(() => import('@shared/components/customLink'))
const HeaderUser = dynamic(() => import('./headerUser'), { ssr: false })

function MainHeader() {
  const sidebarMenu = getHeaderSidebarMenu()
  const data = cricketHeaderMenu
  const [firstParam, setFirstParam] = useState('')
  const allSports = sidebarMenu?.length ? sidebarMenu?.map(data => ({ sTitle: data?.sName, ...data })) : []
  // const [width] = useWindowSize()
  const token = getToken()
  const router = useRouter()
  useEffect(() => {
    if (typeof window !== 'undefined') {
      try {
        const currentFullUrl = window.location.href
        setFirstParam(currentFullUrl.split('/').length < 3 ? '/' : `/${currentFullUrl.split('/').slice(3, 4).join('/')}`)
      } catch (error) {
        console.error('Error getting URL:', error)
        setFirstParam('/')
      }
    }
  }, [router.asPath])

  useGoogleIdentify(token)
  const excludedPaths = [
    '/football-news',
    '/tennis-news',
    '/hockey-india-league',
    '/wpl-womens-indian-premier-league-2025',
    '/champions-trophy-2025',
    '/chess-2024',
    '/tennis',
    '/olympics',
    '/hockey',
    '/advertise-with-us',
    '/golf',
    '/boxing',
    '/chess',
    '/kabaddi',
    '/badminton',
    '/formula-1',
    '/ipl-indian-premier-league-2025',
    '/formula1-racing'
  ]

  const shouldShowHeaderMenu = !excludedPaths.some(path => router.asPath.startsWith(path))

  const excludedSubHeader = ['/formula1-racing', '/wwe']

  const shouldShowSubheader = !excludedSubHeader.some(path => router.pathname.startsWith(path))

  const isHomePage = router.pathname === '/'
  return (
    <>
      <div
        id="g_id_onload"
        data-type="onload"
        data-shape="rectangular"
        data-theme="filled_blue"
        data-auto_prompt="true"
        style={{ position: 'fixed', top: 0, right: 0, width: token ? 0 : 'auto', zIndex: 999999 }}
      />
      {/* <DownloadBanner /> */}
      <header className={`${styles.siteHeader} ${isHomePage ? styles.homeHeader : ''}`}>
        <CommonHeader
          data={data}
          Container={Container}
          CustomLink={CustomLink}
          allSports={allSports}
          firstParam={firstParam}
          pageRouterComp={true}
          InternalRouting={true}
          logoSection={logo => {
            return (
              <CustomLink prefetch={false} href="/">
                <div className={`${styles.logoWrapper} d-flex align-items-center`}>
                  <div className={`${styles.logo} navbar-brand d-block m-0 p-0`}>
                    <MyImage src={logo} alt="logo" />
                  </div>
                </div>
              </CustomLink>
            )
          }}
          rightSideSection={
            <Navbar className={`${styles.navbar} align-items-center`}>
              <Nav className={`${styles.nav} gap-4 ms-auto align-items-center position-relative pb-0`}>
                <div className="d-flex align-items-center">
                  <HeaderUser styles={styles} />
                </div>
                <DarkModeButton />
              </Nav>
            </Navbar>
          }
          otnCricketPointer={true}
        />
      </header>

      <CommonHeaderMobile
        data={data}
        pageRouterComp={true}
        otnCricketPointer={true}
        Container={Container}
        firstParam={firstParam}
        CustomLink={CustomLink}
        allSports={allSports}
      />

      {shouldShowSubheader && (
        <div className={`${styles.siteSecondaryHeader} ${isHomePage ? styles.homeHeader : ''}`}>
          <Container>
            <div className={`${styles.secondaryMenu} d-flex`}>{shouldShowHeaderMenu && <HeaderMenu />}</div>
          </Container>
        </div>
      )}

      {/* {width < 992 && (
           <div className={`${styles.sgMediaContainer} w-full`}>
           <div className={`${styles.sgmedia} d-flex align-items-center font-semi w-full justify-content-center`}>
             <span className={`${styles.powered} overflow-hidden text-nowrap me-2`}>Powered By</span>
             <MyImage src={sgMedia} alt="SG media" width="100px" height="20px" />
           </div>
         </div>
      )} */}
      {/* SG logo for all page */}
      {/* {showMenu && <HeaderSidebar showMenu={showMenu} handleMenu={() => handleMenuClose()} />} */}
      <MobileMenu />
    </>
  )
}
export default MainHeader
